import React from "react";

function FairmentIntroCard({ onStart, isLoading = false, quotaInfo = null }) {
  return (
    <div
      style={{
        width: "100%",
        maxWidth: 520,
        background: "rgba(255,255,255,0.85)",
        borderRadius: 24,
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
        padding: "44px 34px",
        textAlign: "center",
        backdropFilter: "blur(8px)",
      }}
      className="introCard__glass-card"
    >
      <h2 style={{ marginBottom: 24, color: "#000000", fontWeight: 700, fontSize: 28, letterSpacing: 0.5 }}>
      Sag uns, was dich wirklich interessiert!
      </h2>
      <p style={{ fontSize: 18, color: "black", marginBottom: 18 }}>
      Vielen Dank für deine Bereitschaft, uns zu unterstützen. Deine Antworten helfen uns besser zu werden.   
        Wir wollen verstehen, was dich bewegt:<br />
        Was dich interessiert, was dir hilft und wie wir dich auf deiner Reise zu besserer Darmgesundheit noch besser begleiten können.

      </p>
      <p style={{ fontSize: 17, color: "black", marginBottom: 18 }}>
      Mit deinen Antworten hilfst du uns, unsere Produkte, Inhalte und Services so weiterzuentwickeln, dass sie wirklich etwas verändern – für dich und für viele andere.

      </p>

      <p style={{ fontSize: 17, color: "black", marginBottom: 18 }}>
      Deine Teilnahme ist <strong>anonym & DSGVO-konform</strong> und dauert nur ca. <strong>10 Minuten</strong>.
      </p>
      <p style={{ fontSize: 17, color: "black", marginBottom: 18 }}>
      👉 <strong>Jetzt mitmachen und Darmgesundheit gemeinsam in den Mainstream bringen!</strong>
      </p>

      <button
        style={{
          marginTop: 18,
          background: isLoading ? "#666" : "#000000",
          color: "#fff",
          fontWeight: 600,
          fontSize: 20,
          padding: "15px 38px",
          border: "none",
          borderRadius: 14,
          cursor: isLoading ? "not-allowed" : "pointer",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          transition: "all 0.2s ease",
          outline: "none",
          opacity: isLoading ? 0.7 : 1
        }}
        onClick={onStart}
        disabled={isLoading}
      >
        {isLoading ? 'Einen Moment...' : 'Fragebogen starten'}
      </button>
    </div>
  );
}

export default FairmentIntroCard;